import React from 'react';
import BaseTemplate from './base.js';
import Details from './details.js';
import {RatingElement,ContentElement} from './elements.js';
import * as u from '../utils.js'

/*---------------------------------------------*/

/* TODO:
	Font size responsiveness?
	Quote size without container?
	Testimonial padding top/bottom in mobile?
*/

const MOBILE_STYLE = {
	container: {
		paddingTop: 28,
		paddingBottom: 28,
		paddingLeft: 24,
		paddingRight: 24
	},
	content: {
		lineHeight: 1.5
	}
}

const BREAKPOINTS_STYLES = {
	400: {
		container: {
			paddingTop: 28,
			paddingBottom: 28,
			paddingLeft: 24,
			paddingRight: 24
		},
		content: {
			lineHeight: 1.5
		}
	},
	720: {
		container: {
			paddingTop: 36,
			paddingBottom: 32,
			paddingLeft: 40,
			paddingRight: 40
		},
		content: {
			lineHeight: 1.5
		}
	},
	960: {
		container: {
			paddingTop: 36,
			paddingBottom: 32,
			paddingLeft: 48,
			paddingRight: 48
		},
		content: {
			lineHeight: 1.75
		}
	},
	Infinity: {
		container: {
			paddingTop: 36,
			paddingBottom: 32,
			paddingLeft: 56,
			paddingRight: 56
		},
		content: {
			lineHeight: 1.75
		}
	}
}

/*---------------------------------------------*/

export default class QuoteTemplate extends BaseTemplate {
	
	getComposition() {
		let textPosition = this.context.get('template.textposition');
		let composition = (textPosition === 'top') ? ['content','details'] : ['details','content'];
		
		let ratingEnabled = this.context.get('fields.rating.enabled');
		if (ratingEnabled && this.props.data.rating) {
			let ratingPosition = this.context.get('template.ratingposition2');
			ratingPosition = {
				'top': {
					'above': 0,
					'below': 1
				},
				'bottom': {
					'above': 1,
					'below': 2
				}
			}[textPosition][ratingPosition];
			
			composition.splice(ratingPosition,0,'rating');
		}
		
		return composition.join('-');
	}
	
	render() {
		let data = this.props.data;
		let quoteMargin = 1*this.context.get('fields.quote.margin',8);
		let alignment = this.context.get('template.quote.alignment','center');
		let infoCellStyle = {
			gridColumn: (alignment !== 'right') ? 3 : 1,
			minWidth: 0 // prevent grid from exceeding 100% width https://stackoverflow.com/a/43312314
		}

		let textFontStyle = u.getFontStyle(this.context,'style.text.font');
		textFontStyle.fontSize = this.context.get('template.quote.textSize') || textFontStyle.fontSize;

		let responsiveStyle = this.context.isMobile() ? MOBILE_STYLE : u.getBreakpointStyle(BREAKPOINTS_STYLES,this.props.width);
		let styles = {
			container: {
				...this.props.baseStyle,
				...responsiveStyle.container,
				textAlign: alignment,
				width: '100%'
			},
			grid: {
				display: 'inline-grid',
				alignItems: 'start',
				width: '100%',

				// auto for the 3rd/1st column doesn't use all the remaining space
				gridTemplateColumns: (alignment !== 'right') ? `auto ${quoteMargin}px 1fr` : `1fr ${quoteMargin}px auto`
			},
			quote: {
				gridColumn: (alignment !== 'right') ? 1 : 3
			},
			content: {
				...infoCellStyle,
				...responsiveStyle.content,
			},
			rating: {
				...infoCellStyle
			},
			details: {
				...infoCellStyle
			}
		}

		if (this.context.get('style.lineHeight')) {
			styles.content.lineHeight = this.context.get('style.lineHeight');
		}
		
		let aligns = {
			top: {},
			size: {},
			sizeBottom: {}
		}

		if (this.props.content) {
			return (
				<div className="testimonial" style={styles.container} align-group={this.props.alignGroup} ref={this.container}>
					{this.props.content}
				</div>
			)
		}

		let composition = this.getComposition();		
		switch (composition) {
			/*----- 2 elements -----*/
			case 'content-details':
				aligns.top.details = 1;
				aligns.top.content = 2;
				aligns.top.quote = 3;
				styles.content.marginBottom = 19;
				break;
		
			case 'details-content':
				aligns.top.quote = 1;
				aligns.top.content = 2;
				aligns.top.rating = 3;

				styles.details.marginBottom = 22;
				break;
					
			// NO IMAGE
			case 'rating-details-content':
				styles.rating.marginBottom = 12;
				styles.details.marginBottom = 22;
				break;

			case 'details-rating-content':
				aligns.top.quote = 1;
				aligns.top.content = 2;
				aligns.top.rating = 3;

				styles.details.marginBottom = 17;
				styles.rating.marginBottom = 5;
				break;
					
			case 'rating-content-details':
				aligns.top.details = 1;
				aligns.top.content = 2;
				aligns.top.quote = 3;

				styles.rating.marginBottom = 5;
				styles.content.marginBottom = 20;
				break;
			
			case 'content-rating-details':
				aligns.top.details = 1;

				styles.content.marginBottom = 7;
				styles.rating.marginBottom = 20;
				break;
			
			case 'content-details-rating':
				aligns.top.details = 1;

				styles.content.marginBottom = 20;
				styles.details.marginBottom = 9;
				break;
			
			case 'details-content-rating':
				aligns.top.quote = 1;
				aligns.top.content = 2;

				styles.details.marginBottom = 22;
				styles.rating.marginTop = 7;
				break;

			/*----- 4 elements -----*/
			// x = ['image-content-details','image-details-content','details-content-image','details-image-content','content-image-details','content-details-image',]
			// copy([].concat.apply([], x.map(function(c) { return [0,1,2,3].map(function(index){ d = c.split('-'); d.splice(index,0,'rating'); return d.join('-')}) })).join('\n'))

			/* composition #1 */
			case 'image-content-details':
			case 'rating-image-content-details':
				styles.rating.marginBottom = 16;
				styles.image.marginBottom = 21;
				styles.content.marginBottom = 19;
				break;
			case 'image-rating-content-details':
				styles.image.marginBottom = 24;
				styles.rating.marginBottom = 4;
				styles.content.marginBottom = 20;
				break;
			case 'image-content-rating-details':
				styles.image.marginBottom = 20;
				styles.content.marginBottom = 8;
				styles.rating.marginBottom = 20;
				break;
			case 'image-content-details-rating':
				styles.image.marginBottom = 20;
				styles.content.marginBottom = 20;
				styles.details.marginBottom = 9;
				break;

			/* composition #2 */
			case 'image-details-content':
			case 'rating-image-details-content':
				styles.rating.marginBottom = 16;
				styles.image.marginBottom = 12;
				styles.content.marginTop = 22;
				break;
			case 'image-rating-details-content':
				styles.image.marginBottom = 8;
				styles.rating.marginBottom = 20;
				styles.details.marginBottom = 22;
				break;
			case 'image-details-rating-content':
				aligns.top.content = 1;
				aligns.top.rating = 2;
				
				styles.image.marginBottom = 12;
				styles.details.marginBottom = 17;
				styles.rating.marginBottom = 5;
				break;
			case 'image-details-content-rating':
				styles.image.marginBottom = 12;
				styles.details.marginBottom = 22;
				styles.content.marginBottom = 7;
				break;

			/* composition #3 */
			case 'details-content-image':
			case 'rating-details-content-image':
				styles.rating.marginBottom = 12;
				styles.details.marginBottom = 22;
				styles.content.marginBottom = 23;
				break;
			case 'details-rating-content-image':
				styles.details.marginBottom = 17;
				styles.rating.marginBottom = 5;
				styles.content.marginBottom = 23;
				break;
			case 'details-content-rating-image':
				styles.details.marginBottom = 22;
				styles.rating.marginTop = 7;
				styles.image.marginTop = 24;
				break;
			case 'details-content-image-rating':
				styles.details.marginBottom = 21;
				styles.content.marginBottom = 23;
				styles.image.marginBottom = 16;
				break;

			/* composition #6 */
			case 'details-image-content':
			case 'rating-details-image-content':
				styles.rating.marginBottom = 12;
				styles.details.marginBottom = 9;
				styles.image.marginBottom = 21;
				break;
			case 'details-rating-image-content':
				styles.details.marginBottom = 17;
				styles.rating.marginBottom = 8;
				styles.image.marginBottom = 21;
				break;
			case 'details-image-rating-content':
				styles.details.marginBottom = 9;
				styles.image.marginBottom = 24;
				styles.rating.marginBottom = 5;
				break;
			case 'details-image-content-rating':
				styles.details.marginBottom = 9;
				styles.image.marginBottom = 21;
				styles.content.marginBottom = 7;
				break;

			/* composition #4 */
			case 'content-image-details':
			case 'rating-content-image-details':
				styles.rating.marginBottom = 5;
				styles.content.marginBottom = 31;
				styles.image.marginBottom = 12;
				break;
			case 'content-rating-image-details':
				styles.content.marginBottom = 7;
				styles.rating.marginBottom = 32;
				styles.image.marginBottom = 12;
				break;
			case 'content-image-rating-details':
				styles.image.marginTop = 31;
				styles.rating.marginTop = 8;
				styles.details.marginTop = 20;
				break;
			case 'content-image-details-rating':
				styles.content.marginBottom = 31;
				styles.image.marginBottom = 12;
				styles.rating.marginTop = 17;
				break;

			/* composition #5 */
			case 'content-details-image':
			case 'rating-content-details-image':
				styles.rating.marginBottom = 5;
				styles.content.marginBottom = 27;
				styles.image.marginTop = 9;
				break;
			case 'content-rating-details-image':
				styles.content.marginBottom = 8;
				styles.rating.marginBottom = 20;
				styles.details.marginBottom = 9;
				break;
			case 'content-details-rating-image':
				styles.content.marginBottom = 27;
				styles.details.marginBottom = 17;
				styles.rating.marginBottom = 8;
				break;
			case 'content-details-image-rating':
				styles.content.marginBottom = 27;
				styles.details.marginBottom = 9;
				styles.image.marginBottom = 8;
				break;

			default:
				console.error("Invalid composition value",composition);
				break;
		}

		
		let partialDisplay = true;
		switch (this.props.part) {
			case 'top':
				composition = composition.split(/-?image-?/)[0];
				break;
			
			case 'bottom':
				composition = composition.split(/-?image-?/)[1];
				break;
			
			case 'thumbnail':
				let scaleBy = (this.context.get('layout.thumbnails.scaling',15) / 100);
				let boxShadow = null;
				let border = null;
				if (this.props.selected) {
					let shadowX = this.context.get('layout.thumbnails.selected.boxShadow.x');
					let shadowY = this.context.get('layout.thumbnails.selected.boxShadow.y');
					let shadowBlur = this.context.get('layout.thumbnails.selected.boxShadow.blur');
					let shadowSpread = this.context.get('layout.thumbnails.selected.boxShadow.spread');
					let shadowColor = u.renderColor(this.context.get('layout.thumbnails.selected.boxShadow.color','black'));
					boxShadow = `${shadowX}px ${shadowY}px ${shadowBlur}px ${shadowSpread}px ${shadowColor}`

					let borderWidth = this.context.get('layout.thumbnails.selected.border.width');
					let borderColor = u.renderColor(this.context.get('layout.thumbnails.selected.border.color','black'));
					border = `${borderWidth}px solid ${borderColor}`;
				}

				styles.image = {
					...styles.image,
					marginLeft: !this.props.first && this.context.get('layout.thumbnails.spacing1',20)/2,
					marginRight: !this.props.last && this.context.get('layout.thumbnails.spacing1',20)/2,
					marginTop: (styles.image.marginTop || 0) + this.context.get('layout.thumbnails.vspacing1',0),
					marginBottom: (styles.image.marginBottom || 0) + this.context.get('layout.thumbnails.vspacing2',0),
					boxShadow: boxShadow,
					border: border
				}

				composition = 'image';
				break;
			
			default:
				partialDisplay = false;
				break;
		}

		let alignProps = {};
		if (this.props.alignGroup) {
			Object.keys(aligns.top).forEach(key => {
				if (aligns.top[key]) {
					alignProps[key] = {
						[(key === 'details' || key === 'quote') ? 'align-top' : 'alignTop']: this.props.alignGroup+aligns.top[key]
					}
				}
			})

			Object.keys(aligns.size).forEach(key => {
				if (aligns.size[key]) {
					alignProps[key] = {
						[(key === 'details' || key === 'quote') ? 'align-group' : 'alignGroup']: this.props.alignGroup+aligns.size[key]
					}
				}
			})

			Object.keys(aligns.sizeBottom).forEach(key => {
				if (aligns.sizeBottom[key]) {
					alignProps[key] = {
						[(key === 'details' || key === 'quote') ? 'align-size-bottom' : 'alignSizeBottom']: this.props.alignGroup+aligns.sizeBottom[key]
					}
				}
			})
		}

		let components = {
			content: <ContentElement {...alignProps.content} text={data.text} font={textFontStyle} baseStyle={styles.content} key="content" />,
			rating: <RatingElement {...alignProps.rating} rating={data.rating} baseStyle={styles.rating} key="rating" />,
			details: <div {...alignProps.details} style={styles.details} key="details"><Details data={data} inline={true} alignment={alignment} /></div>
		}
		
		let compositionList = composition.split('-');
		let contentIndex = compositionList.indexOf('content');

		styles.quote.gridRow = (contentIndex+1);

		let content = compositionList.map((type) => components[type]);
		if (partialDisplay)
			return content;
			
		let quoteSize = this.context.get('template.quote.iconSize');
		if (!quoteSize) {
			quoteSize = ((textFontStyle.fontSize-20)/2 + 20);
			quoteSize = Math.max(quoteSize,18);
		}

		let quoteOffset = 1*this.context.get('template.quote.iconOffset') || (6 + (quoteSize-18)/2);
		let quoteColor = u.renderColor(this.context.get('style.text.color'));
		let lineHeight = 1*this.context.get('style.lineHeight',1.75,1.5) || (!this.context.isMobile() ? 1.75 : 1.5);
		
		styles.quote.marginTop = (textFontStyle.fontSize*lineHeight - quoteSize) / 2;
		styles.quote.transform = `translateY(-${quoteOffset}px)`;

		let hasContainer = this.context.get('template.container',true);
		if (!hasContainer) {
			styles.container.paddingTop = 0;
			styles.container.paddingBottom = 0;
			styles.container.paddingLeft = 0;
			styles.container.paddingRight = 0;
		}

		return (
			<div className="testimonial" style={styles.container} align-group={this.props.alignGroup} ref={this.container}>
				<div style={styles.grid}>
					<div style={styles.quote} {...alignProps.quote}>
						<svg height={quoteSize} viewBox="0 0 28 20">
							<g fill="none" fillRule="evenodd">
								<path d="M0 0h28v20H0z"/>
								<path fill={quoteColor} fillRule="nonzero" d="M9.998 0L11 2a8.981 8.981 0 0 0-3.52 2.535c-1.575 1.61-2.395 3.237-2.395 4.71 0 .504.085.949.377 1.104.291.174.605.151.82.151.738-.097 1.225-.151 1.458-.151 1.245 0 2.266.45 3.064 1.352.797.9 1.196 1.99 1.196 3.27 0 1.435-.438 2.63-1.313 3.59S8.606 20 7.069 20c-1.809 0-3.273-.644-4.391-1.933C1.559 16.778 1 15.058 1 12.907c0-2.053.715-4.24 2.145-6.555C4.575 4.036 6.263 1.919 9.998 0zm15 0L26 2a8.981 8.981 0 0 0-3.52 2.535c-1.575 1.61-2.395 3.237-2.395 4.71 0 .504.085.949.377 1.104.291.174.605.151.82.151.738-.097 1.225-.151 1.458-.151 1.245 0 2.266.45 3.064 1.352.797.9 1.196 1.99 1.196 3.27 0 1.435-.438 2.63-1.313 3.59S23.606 20 22.069 20c-1.809 0-3.273-.644-4.391-1.933C16.559 16.778 16 15.058 16 12.907c0-2.053.715-4.24 2.145-6.555 1.43-2.316 3.118-4.433 6.853-6.352z"/>
							</g>
						</svg>
					</div>
					{content}
				</div>
			</div>
		)
	}
}

/*---------------------------------------------*/
